
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18.33a8.333 8.333 0 110-16.666 8.333 8.333 0 010 16.667zm-.83-5l5.892-5.892-1.179-1.178-4.714 4.714-2.357-2.357-1.178 1.178 3.535 3.536z","fill":"#27AE60"}})])
          )
        }
      }
    